import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const LocationStep = ({ selectedLocations, onToggle }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const turkishCities = [
    { id: 'istanbul', name: 'İstanbul', region: 'Marmara', icon: 'Building2' },
    { id: 'izmir', name: 'İzmir', region: 'Ege', icon: 'Waves' },
    { id: 'antalya', name: 'Antalya', region: 'Akdeniz', icon: 'Sun' },
    { id: 'mugla', name: 'Muğla', region: 'Ege', icon: 'Palmtree' },
    { id: 'aydin', name: 'Aydın', region: 'Ege', icon: 'MapPin' },
    { id: 'canakkale', name: 'Çanakkale', region: 'Marmara', icon: 'Anchor' },
    { id: 'balikesir', name: 'Balıkesir', region: 'Marmara', icon: 'Mountain' },
    { id: 'mersin', name: 'Mersin', region: 'Akdeniz', icon: 'Ship' },
    { id: 'hatay', name: 'Hatay', region: 'Akdeniz', icon: 'Compass' },
    { id: 'samsun', name: 'Samsun', region: 'Karadeniz', icon: 'CloudRain' },
    { id: 'trabzon', name: 'Trabzon', region: 'Karadeniz', icon: 'Trees' },
    { id: 'rize', name: 'Rize', region: 'Karadeniz', icon: 'Coffee' }
  ];

  const filteredCities = turkishCities?.filter(city =>
    city?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    city?.region?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Tercih Ettiğiniz Bölgeler
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Paddle yapmayı tercih ettiğiniz şehirleri seçin. Size yakın etkinlikleri önerebileceğiz
        </p>
      </div>
      <div className="mb-6 md:mb-8">
        <Input
          type="search"
          placeholder="Şehir veya bölge ara..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="max-w-md mx-auto"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
        {filteredCities?.map((city) => {
          const isSelected = selectedLocations?.includes(city?.id);
          
          return (
            <button
              key={city?.id}
              onClick={() => onToggle(city?.id)}
              className={`p-5 md:p-6 lg:p-7 rounded-xl md:rounded-2xl border-2 transition-smooth text-left ${
                isSelected
                  ? 'border-[var(--color-primary)] bg-[rgba(27,75,102,0.08)] shadow-organic'
                  : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)] hover:shadow-organic-sm'
              }`}
            >
              <div className="flex items-start gap-4 mb-3">
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0 ${
                    isSelected
                      ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
                      : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'
                  }`}
                >
                  <Icon name={city?.icon} size={24} />
                </div>
                {isSelected && (
                  <Icon name="CheckCircle2" size={20} className="text-[var(--color-primary)] flex-shrink-0" />
                )}
              </div>
              <h3 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-1">
                {city?.name}
              </h3>
              <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
                {city?.region} Bölgesi
              </p>
            </button>
          );
        })}
      </div>
      {filteredCities?.length === 0 && (
        <div className="text-center py-12 md:py-16">
          <Icon name="Search" size={48} className="text-[var(--color-muted-foreground)] mx-auto mb-4" />
          <p className="text-base md:text-lg text-[var(--color-muted-foreground)]">
            Aradığınız şehir bulunamadı
          </p>
        </div>
      )}
    </div>
  );
};

export default LocationStep;